import {
  POST_CUSTOMER,
  POST_CUSTOMER_ERROR,
  POST_CUSTOMER_SUCCESS,
  GET_CUSTOMER,
  GET_CUSTOMER_ERROR,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_OPTION_USERS,
  GET_CUSTOMER_OPTION_USERS_SUCCESS,
  GET_CUSTOMER_OPTION_USERS_ERROR,
  POST_CUSTOMER_MANAGER,
  POST_CUSTOMER_MANAGER_ERROR,
  POST_CUSTOMER_MANAGER_SUCCESS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_DETAILS_ERROR,
  GET_CUSTOMER_DETAILS_SUCCESS,
  POST_EDIT_CUSTOMER_ERROR,
  POST_EDIT_CUSTOMER_SUCCESS,
  POST_EDIT_CUSTOMER,
  GET_MANAGER_INFO,
  GET_MANAGER_INFO_ERROR,
  GET_MANAGER_INFO_SUCCESS,
  POST_EDIT_MANAGER_INFO,
  POST_EDIT_MANAGER_INFO_SUCCESS,
  POST_EDIT_MANAGER_INFO_ERROR,
  POST_EDIT_NAMECARD,
  POST_EDIT_NAMECARD_ERROR,
  POST_EDIT_NAMECARD_SUCCESS,
  DEL_CUSTOMER,
  DEL_CUSTOMER_SUCCESS,
  DEL_CUSTOMER_ERROR,
  DEL_CUSTOMER_MANAGER,
  DEL_CUSTOMER_MANAGER_ERROR,
  DEL_CUSTOMER_MANAGER_SUCCESS,
  SET_LAST_TAB,
  SET_ACCOUNT_TAB,
  POST_ACC_FILE,
  POST_ACC_FILE_SUCCESS,
  POST_ACC_FILE_ERROR,
  GET_NEWS_DAUM,
  GET_NEWS_DAUM_ERROR,
  GET_NEWS_DAUM_SUCCESS,
  GET_NEWS_GOOGLE,
  GET_NEWS_GOOGLE_ERROR,
  GET_NEWS_GOOGLE_SUCCESS,
  GET_NEWS_NAVER,
  GET_NEWS_NAVER_ERROR,
  GET_NEWS_NAVER_SUCCESS,
  GET_CUSTOMER_FEEDBACK,
  GET_CUSTOMER_FEEDBACK_ERROR,
  GET_CUSTOMER_FEEDBACK_SUCCESS,
  GET_CUSTOMER_NEEDS,
  GET_CUSTOMER_NEEDS_ERROR,
  GET_CUSTOMER_NEEDS_SUCCESS,
  GET_CUSTOMER_LOGS,
  GET_CUSTOMER_LOGS_ERROR,
  GET_CUSTOMER_LOGS_SUCCESS
} from '../../constants/actionTypes';

const initialState = {
  getCustomerResponse: null,
  postCustomerResponse: null,
  loading: true,
  list: null,
  listCounts: null,
  userLists: null,
  userListsResponse: null,
  postCustomerMangerResponse: null,
  getCustomerDetailsResponse: null,
  customerDetails: null,
  postCustomerEditResponse: null,
  getMangerResponse: null,
  managerDetails: null,
  postManagerEditResponse: null,
  postNamecardResponse: null,
  deleteCustomerRepsonse: null,
  deleteCustomerManagerResponse: null,
  customerStoredData: null,
  tabStoreData: null,
  accountBody: null,
  postAccFileRes: null,
  googleResponse: null,
  naverResponse: null,
  daumResponse: null,
  customerNeedsResponse: null,
  customerFeedbacksResponse: null,
  customerLogsResponse: null,
}

const Customer = (state = initialState, action) => {
  switch (String(action.type)) {
    case POST_CUSTOMER:
      return { ...state, loading: true, postCustomerResponse: false, accountBody: action.payload }
    case POST_CUSTOMER_SUCCESS:
      return { ...state, loading: false, postCustomerResponse: true }
    case POST_CUSTOMER_ERROR:
      return { ...state, loading: false, postCustomerResponse: false }

    case GET_CUSTOMER:
      return { ...state, loading: true, customerStoredData: action.payload }
    case GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteCustomerRepsonse: false,
        getCustomerResponse: true,
        postCustomerResponse: false,
        list: action.payload.response.message[0],
        listCounts: action.payload.response.message[1][0].totalCnt,
      }
    case GET_CUSTOMER_ERROR:
      return {
        ...state,
        loading: false,
        getCustomerResponse: false,
        postCustomerResponse: false,
        deleteCustomerRepsonse: false
      }

    case GET_CUSTOMER_OPTION_USERS:
      return { ...state, userListsResponse: false }
    case GET_CUSTOMER_OPTION_USERS_SUCCESS:
      return { ...state, userListsResponse: true, userLists: action.payload.response.message }
    case GET_CUSTOMER_OPTION_USERS_ERROR:
      return { ...state, userListsResponse: false, }

    case POST_CUSTOMER_MANAGER:
      return { ...state, loading: true, postCustomerMangerResponse: false }
    case POST_CUSTOMER_MANAGER_SUCCESS:
      return { ...state, loading: false, postCustomerMangerResponse: true }
    case POST_CUSTOMER_MANAGER_ERROR:
      return { ...state, loading: false, postCustomerMangerResponse: false }

    case GET_CUSTOMER_DETAILS:
      return { ...state, loading: true, postCustomerMangerResponse: false }
    case GET_CUSTOMER_DETAILS_SUCCESS:
      return { ...state, loading: false, getCustomerDetailsResponse: true, customerDetails: action.payload.response.message[0] }
    case GET_CUSTOMER_DETAILS_ERROR:
      return { ...state, loading: false, getCustomerDetailsResponse: false }

    case POST_EDIT_CUSTOMER:
      return { ...state, loading: true, postCustomerEditResponse: false }
    case POST_EDIT_CUSTOMER_SUCCESS:
      return { ...state, loading: false, postCustomerEditResponse: true }
    case POST_EDIT_CUSTOMER_ERROR:
      return { ...state, loading: false, postCustomerEditResponse: false }

    case GET_MANAGER_INFO:
      return { ...state, loading: true, postManagerEditResponse: false }
    case GET_MANAGER_INFO_SUCCESS:
      return { ...state, loading: false, getMangerResponse: true, managerDetails: action.payload.response.message[0] }
    case GET_MANAGER_INFO_ERROR:
      return { ...state, loading: false, getMangerResponse: false }

    case POST_EDIT_MANAGER_INFO:
      return { ...state, loading: true, postManagerEditResponse: false }
    case POST_EDIT_MANAGER_INFO_SUCCESS:
      return { ...state, loading: false, postManagerEditResponse: true }
    case POST_EDIT_MANAGER_INFO_ERROR:
      return { ...state, loading: false, postManagerEditResponse: false }

    case POST_EDIT_NAMECARD:
      return { ...state, loading: true }
    case POST_EDIT_NAMECARD_SUCCESS:
      return { ...state, loading: false, postNamecardResponse: true }
    case POST_EDIT_NAMECARD_ERROR:
      return { ...state, loading: false, postNamecardResponse: false }

    case DEL_CUSTOMER:
      return { ...state, loading: true }
    case DEL_CUSTOMER_SUCCESS:
      return { ...state, deleteCustomerRepsonse: true }
    case DEL_CUSTOMER_ERROR:
      return { ...state, deleteCustomerRepsonse: false }

    case DEL_CUSTOMER_MANAGER:
      return { ...state, loading: true }
    case DEL_CUSTOMER_MANAGER_SUCCESS:
      return { ...state, loading: false, deleteCustomerManagerResponse: true }
    case DEL_CUSTOMER_MANAGER_ERROR:
      return { ...state, loading: false, deleteCustomerManagerResponse: false }

    case SET_LAST_TAB:
      return {
        ...state, tabStoreData: action.payload
      }
    case SET_ACCOUNT_TAB:
      return {
        ...state, accountKey: action.payload
      }

    case POST_ACC_FILE:
      return { ...state, loading: true }
    case POST_ACC_FILE_SUCCESS:
      return { ...state, loading: false, postAccFileRes: true }
    case POST_ACC_FILE_ERROR:
      return { ...state, loading: false, postAccFileRes: false }

    case GET_NEWS_DAUM:
      return { ...state, loading: true }
    case GET_NEWS_DAUM_SUCCESS:
      return { ...state, loading: false, daumResponse: action.payload.response.message }
    case GET_NEWS_DAUM_ERROR:
      return { ...state, loading: false, daumResponse: false }

    case GET_NEWS_NAVER:
      return { ...state, loading: true }
    case GET_NEWS_NAVER_SUCCESS:
      return { ...state, loading: false, naverResponse: action.payload.response.message }
    case GET_NEWS_NAVER_ERROR:
      return { ...state, loading: false, naverResponse: null }

    case GET_NEWS_GOOGLE:
      return { ...state, loading: true }
    case GET_NEWS_GOOGLE_SUCCESS:
      return { ...state, loading: false, googleResponse: action.payload.response.message }
    case GET_NEWS_GOOGLE_ERROR:
      return { ...state, loading: false, googleResponse: null }

    case GET_CUSTOMER_NEEDS:
      return { ...state, loading: true }
    case GET_CUSTOMER_NEEDS_SUCCESS:
      return { ...state, loading: false, customerNeedsResponse: action.payload.response.message }
    case GET_CUSTOMER_NEEDS_ERROR:
      return { ...state, loading: false, customerNeedsResponse: null }

    case GET_CUSTOMER_FEEDBACK:
      return { ...state, loading: true }
    case GET_CUSTOMER_FEEDBACK_SUCCESS:
      return { ...state, loading: false, customerFeedbacksResponse: action.payload.response.message }
    case GET_CUSTOMER_FEEDBACK_ERROR:
      return { ...state, loading: false, customerFeedbacksResponse: null }

    case GET_CUSTOMER_LOGS:
      return { ...state, loading: true }
    case GET_CUSTOMER_LOGS_SUCCESS:
      return { ...state, loading: false, customerLogsResponse: action.payload.response.message[0] }
    case GET_CUSTOMER_LOGS_ERROR:
      return { ...state, loading: false, customerLogsResponse: null }

    default:
      return { ...state };
  }
}
export default Customer;